module.exports = {
  domain: 'A',
  title: 'Agreeableness',
  shortDescription: 'Η συμβατότητα αντικατοπτρίζει μεμονωμένες διαφορές όσον αφορά τη συνεργασία και την κοινωνική αρμονία. Συμφωνήσιμα άτομα αξία να πάρει μαζί με άλλους.',
  description: `Ως εκ τούτου, είναι ευγενικοί, φιλικοί,
γενναιόδωρη, χρήσιμη και πρόθυμη να συμβιβαστεί με τα συμφέροντά τους
οι υπολοιποι'. Οι συμπολίτες έχουν επίσης μια αισιόδοξη άποψη για τον άνθρωπο
φύση. Πιστεύουν ότι οι άνθρωποι είναι βασικά ειλικρινείς, αξιοπρεπείς και
αξιόπιστος.   
<br /><br />
Τα δυσάρεστα άτομα θέτουν το συμφέρον αυτοπεποίθησης πιο πάνω
οι υπολοιποι. Είναι γενικά αδιάφοροι με την ευημερία των άλλων και
επομένως είναι απίθανο να επεκταθούν και για άλλους ανθρώπους.
Μερικές φορές ο σκεπτικισμός τους για τα κίνητρα των άλλων προκαλεί την ύπαρξή τους
ύποπτο, εχθρικό και μη συνεργάσιμο.
<br /><br />
Η ευκολία είναι προφανώς επωφελής για την επίτευξη και τη διατήρηση
δημοτικότητα. Οι συμπονετικοί άνθρωποι προτιμούν περισσότερο από το δυσάρεστο
Ανθρωποι. Από την άλλη πλευρά, η ευκολία δεν είναι χρήσιμη σε καταστάσεις
που απαιτούν σκληρές ή απόλυτες αντικειμενικές αποφάσεις. Δυσάρεστος
οι άνθρωποι μπορούν να κάνουν εξαιρετικούς επιστήμονες, κριτικούς ή στρατιώτες.`,
  results: [
    {
      score: 'low', // do not translate this line
      text: `Το σκορ σας για το Agreeableness είναι χαμηλό, γεγονός που δείχνει λιγότερη ανησυχία
με τις ανάγκες των άλλων παρά με τη δική σας. Οι άνθρωποι σας βλέπουν σκληρό,
κρίσιμη και χωρίς συμβιβασμούς.`
    },
    {
      score: 'neutral', // do not translate this line
      text: `Το επίπεδο συμφωνίας σας είναι μέσο, γεγονός που υποδηλώνει κάποια ανησυχία
με τις ανάγκες των άλλων, αλλά, γενικά, την απροθυμία να θυσιάσουν
τον εαυτό σας για τους άλλους.`
    },
    {
      score: 'high', // do not translate this line
      text: `Το υψηλό επίπεδο συμφωνίας σας δείχνει έντονο ενδιαφέρον
τις ανάγκες και την ευημερία των άλλων. Είστε ευχάριστοι, συμπαθητικοί και
συνεταιρισμού. `
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Trust',
      text: `Ένα άτομο με μεγάλη εμπιστοσύνη υποθέτει ότι οι περισσότεροι άνθρωποι
είναι δίκαιες, ειλικρινείς και έχουν καλές προθέσεις. Άτομα με χαμηλή εμπιστοσύνη
Βλέπετε τους άλλους ως εγωιστικούς, υποτιμημένους και δυνητικά επικίνδυνους.`
    },
    {
      facet: 2,
      title: 'Morality',
      text: `Οι υψηλοί σκόρερ σε αυτή την κλίμακα δεν βλέπουν την ανάγκη
προδοσία ή χειραγώγηση όταν ασχολούνται με άλλους και είναι ως εκ τούτου
ειλικρινής, ειλικρινής και ειλικρινής. Οι χαμηλοί σκοράνοι πιστεύουν ότι είναι σίγουροι
είναι αναγκαία η εξαπάτηση στις κοινωνικές σχέσεις. Ανθρωποι
βρίσκουν σχετικά εύκολο να συνδεθούν με την απλή
υψηλά σκόρερ σε αυτή την κλίμακα. Γενικά το βρίσκουν πιο δύσκολο
να σχετίζονται με τους αθέατους χαμηλός σκόρερ σε αυτή την κλίμακα. Το
θα πρέπει να καταστεί σαφές ότι οι χαμηλοί σκόρερ δεν είναι απίθανοι
ή ανήθικο. Είναι απλώς πιο φυλαγμένοι και λιγότερο πρόθυμοι να ανοίξουν
αποκαλύπτουν όλη την αλήθεια.`
    },
    {
      facet: 3,
      title: 'Altruism',
      text: `Αλτρουιστές άνθρωποι βρίσκουν βοήθεια σε άλλους ανθρώπους
πραγματικά ανταμείβοντας. Ως εκ τούτου, είναι γενικά πρόθυμοι να
βοηθούν εκείνους που έχουν ανάγκη. Αλτρουιστές άνθρωποι το βρίσκουν αυτό
τα πράγματα για τους άλλους είναι μια μορφή αυτοπεποίθησης και όχι
αυτοθυσία. Οι χαμηλοί σκόρερ σε αυτή την κλίμακα δεν τους αρέσουν ιδιαίτερα
βοηθώντας όσους έχουν ανάγκη. Τα αιτήματα για βοήθεια αισθάνονται σαν επιβολή
παρά μια ευκαιρία για αυτοεκτέλεση.`
    },
    {
      facet: 4,
      title: 'Cooperation',
      text: `Άτομα που βαθμολογούνται ψηλά σε αυτή την κλίμακα
αντιπαθητικές αντιπαραθέσεις. Είναι απολύτως πρόθυμοι να συμβιβαστούν ή
να αρνούνται τις δικές τους ανάγκες για να συναντηθούν με τους άλλους. Εκείνοι
οι οποίοι βαθμολογούνται χαμηλά σε αυτή την κλίμακα είναι πιο πιθανό να εκφοβίσουν τους άλλους
να πάρουν το δρόμο τους.`
    },
    {
      facet: 5,
      title: 'Modesty',
      text: `Οι υψηλοί σκόρερ σε αυτή την κλίμακα δεν επιθυμούν να ισχυριστούν
ότι είναι καλύτερα από άλλους. Σε ορισμένες περιπτώσεις αυτή η στάση
μπορεί να προέρχεται από χαμηλή αυτοπεποίθηση ή αυτοπεποίθηση. Παρ 'όλα αυτά,
μερικοί άνθρωποι με υψηλή αυτοεκτίμηση βρίσκουν απροσδόκητα άσχημα. Εκείνοι
που είναι πρόθυμοι να περιγράψουν τον εαυτό τους ως ανώτεροι τείνουν να
να θεωρείται ως δυσάρεστα αλαζονική από άλλους ανθρώπους.`
    },
    {
      facet: 6,
      title: 'Sympathy',
      text: `Οι άνθρωποι που βαθμολογούνται ψηλά σε αυτή την κλίμακα είναι
ειλικρινής και συμπονετικόις. Αισθάνονται τον πόνο των άλλων
αντιφατικά και μετακινούνται εύκολα στην κρίση. Οι χαμηλοί σκόρερ δεν 
επηρεάζονται έντονα από τον ανθρώπινο πόνο. Αυτοί είναι υπερήφανοι
κάνοντας αντικειμενικές κρίσεις βάσει του λόγου. Αφορούν περισσότερο
με αλήθεια και αμερόληπτη δικαιοσύνη παρά με έλεος.`
    }
  ]
}
